import clsx from "clsx";
import { useEffect, useRef, useState } from "react";

import { Icon, RenderWhen } from "../../../../../../../components";
import { StoryParagraphs } from "../../../../../@types/sample_details";
import SampleStory from "../../../../summary/SampleStory";
import { PDFExport } from "../../../@types/PDFExport";

import styles from "../description.module.scss";

type Props = {
  story?: StoryParagraphs;
} & PDFExport;

const MAX_LINES_TO_SHOW = 6;

const Story = ({ story, isPdfView }: Props) => {
  const storyRef = useRef<HTMLDivElement>(null);
  const [isShowButton, setIsShowButton] = useState(false);
  const [isClamp, setIsClamp] = useState(false);

  useEffect(() => {
    if (!storyRef?.current) return;
    const computedStyle = getComputedStyle(storyRef.current);
    let lineHeight = parseFloat(computedStyle.lineHeight);
    // line height can be a string
    if (isNaN(lineHeight)) {
      lineHeight = parseFloat(computedStyle.fontSize) * 1.2;
    }

    if (
      storyRef.current.scrollHeight > lineHeight * MAX_LINES_TO_SHOW &&
      !isPdfView
    ) {
      setIsClamp(true);
      setIsShowButton(true);
    }
  }, [story, isPdfView]);

  return (
    <>
      <SampleStory
        ref={storyRef}
        className={clsx(styles.story, isClamp && styles.line_clamp_active)}
        storyParagraphs={story}
        prefix={<span className={styles.details_prefix}>Details: </span>}
      />
      <RenderWhen condition={isShowButton}>
        <div
          className={`flex flex-gap-2 align-center cursor-pointer ${styles.expand_button}`}
          onClick={() => {
            setIsClamp(prev => !prev);
          }}
          data-testid="report_summary_story_expand_toggle"
        >
          <span className="underline">
            {isClamp ? "Expand" : "Collapse"} Details
          </span>
          <Icon name={isClamp ? "chevron-down" : "chevron-up"} />
        </div>
      </RenderWhen>
    </>
  );
};

export default Story;
